import * as trace from 'owa-trace';
import { getRootStore } from 'satcheljs';
import { useEffect, useState } from 'react';
import { when } from 'mobx';

const STRINGS_STORE_NAME = 'locstrings';

/**
 * Custom hook to determine the load of strings for specified `stringsModuleName`
 * @param stringsModuleName
 * @param sampleStringsKey
 */
export const useMiniStrings = (stringsModuleName: string, sampleStringsKey: string) => {
    const [areStringsLoaded, setStringsLoaded] = useState(false);

    useEffect(() => {
        const loadStrings = async () => {
            try {
                await loadLocalizationStrings(stringsModuleName, sampleStringsKey);
                setStringsLoaded(true);
            } catch (error) {
                trace.errorThatWillCauseAlert(
                    `useMiniStrings: Error while loading the ${stringsModuleName} localization strings ${error}`
                );
            }
        };
        loadStrings();
    }, [stringsModuleName]);

    return areStringsLoaded;
};

/**
 * Returns a promise that is resolved when the locale stings are loaded.
 */
export const loadLocalizationStrings = (
    stringsModuleName: string,
    sampleStringsKey: string
): Promise<void> & {
    cancel(): void;
} =>
    when(() =>
        getRootStore()
            .get(STRINGS_STORE_NAME)
            ?.registeredStringModules?.get(stringsModuleName)
            ?.strings?.get(sampleStringsKey)
    );
